import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * 合并 Tailwind CSS 类名
 * 使用 clsx 处理条件类名，使用 twMerge 合并冲突的 Tailwind 类
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
